




















import { Component, Vue } from "vue-property-decorator"
import authentication from '../services/AuthenticationService'

@Component({

})
export default class LoginView extends Vue {
  public password: string = ''

  public submit () {
    authentication.login(this.password)
    this.password = ''
  }
}
